<template>
<div class="storageoutprint" id="storageoutprint" :style="{ height: `${windowHeight}px`, 'overflow-y': 'scroll' }">
		<el-form>
			<el-card>
				<el-row class="formTitle">
					<el-col :span="5">
						<label for>
							<el-checkbox v-model="remind" :true-label="1" :false-label="0"></el-checkbox>
							<span>需补差价时人工确认</span>
						</label>
					</el-col>
				</el-row>
				<table style="width:99%">
					<tr>
						<td valign="top">
							<div class="formContent">
								<table class="htmltable">
									<tr>
										<td class="tdleft"><span>批 次 号</span></td>
										<td colspan="3">
											<el-input ref="handlebatch" @keyup.enter.native="EnterEvent('handlebatch')" v-model="form.batch"></el-input>
										</td>
									</tr>
									<tr v-for="c in trorder" v-if="c.isshow == 1">
										<td class="tdleft_bold">
											<span>
												<b>{{ c.lable }}</b>
											</span>
										</td>
										<td colspan="3" class="b_font">
											<el-input v-model="form.p_pkval" :ref="c.control" @keyup.enter.native="EnterEvent(c.control)" v-if="c.control == 'pkval'"></el-input>
											<el-input
												v-model="form.subpkval"
												:ref="c.control"
												@keyup.enter.native="EnterEvent(c.control)"
												v-if="c.control == 'subpkval'"
											></el-input>
											<el-input v-model="form.grossweight" :ref="c.control" @keyup.enter.native="EnterEvent(c.control)" v-if="c.control == 'weight'"></el-input>
										</td>
									</tr>
									<tr>
										<td class="tdleft_bold"><span>体  积</span></td>
										<td colspan="3" style="text-align:left;">
											<div style="display:inline;margin-left:10px">
												<span> 长(cm)
													<el-input type="text" style="width:70px" v-model="form.p_length"></el-input>
												</span>
												<span> 宽(cm)
													<el-input type="text" style="width:70px" v-model="form.p_width"></el-input>
												</span>
												<span> 高(cm)
													<el-input type="text" style="width:70px" v-model="form.p_height"></el-input>
												</span>
											</div>
										</td>
									</tr>
								</table>
							</div>
						</td>
						<td valign="top" rowspan="2">
							<div class="formRight">
								<div class="perpkval">
									<span v-if="form.perpkval != ''">上一单 : {{ perpkval }}</span>
								</div>
							</div>
							<div class="formCargo" v-if="issub">
								<label>
									<i class="el-icon-d-arrow-right"></i>
									子订单
								</label>
								<tableui style="width:100%;" editcell="0" :tableData="suborder" :columns="ordercolumns"></tableui>
							</div>
						</td>
					</tr>
					<tr>
						<td style="width:50%;">
							<div class="formCargo">
								<i class="el-icon-d-arrow-right"></i>
								<label>
									已扫描
									<span class="ordercount">{{ scanordercount }}</span>
									单
								</label>
								<label>
									总重量
									<span class="orderweight">{{ scanorderweight }}</span>
								</label>
								<label>
									总金额
									<span class="orderamount">{{ scanorderamount }}</span>
								</label>
							</div>
							<tableui
								style="width:99%;"
								ref="checkweight"
								:tableData="orderTable"
								:columns="scanordercolumns"
							></tableui>
						</td>
					</tr>
				</table>
			</el-card>
		</el-form>
		<errorwin ref="errorwin" @closeerrorwin="closeerrorwin"></errorwin>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import tableui from '@/components/table/tablegrid.vue';
import errorwin from '@/components/order/errorwin.vue';
export default {
	components: {
		tableui,
		errorwin
	},
	props: {
		
	},
	data() {
		return {
			remind:0,
			batch:'',
			trorder: [{ lable: '单 号', control: 'pkval', isshow: 1 }, { lable: '子单号', control: 'subpkval', isshow: 0 }, { lable: '重 量', control: 'weight', isshow: 1 }],
			ordercolumns: [
				{ field: 'p_pkval', title: '单号', type: 'text', width: '150', sortable: false },
				{ field: 'cgprovince', title: '地区', type: 'text', width: '120', sortable: false },
				{ field: 'grossweight', title: '重量', type: 'text', width: '60', sortable: false },
				{ field: 'p_length', title: '长', type: 'text', width: '60', sortable: false },
				{ field: 'p_width', title: '宽', type: 'text', width: '60', sortable: false },
				{ field: 'p_height', title: '高', type: 'text', width: '60', sortable: false }
			],
			scanordercolumns: [
				{ field: 'p_pkval', title: '单号', type: 'text', width: '150', sortable: false },
				{ field: 'cgprovince', title: '地区', type: 'text', width: '120', sortable: false },
				{ field: 'grossweight', title: '重量', type: 'text', width: '60', sortable: false },
				{ field: 'amount', title: '金额', type: 'text', width: '60', sortable: false },
			],
			suborder: [],
			suborderscaned:[],//已扫描子单
			subscanfilish: false, //子单是否扫描完成
			perpkval:'',
			form:{
				p_pkval:'',
				grossweight:'',
				p_length:'',
				p_width:'',
				p_height:'',
				amount:0,
				perpay:0,
				batch:'',
				vipaccount:'',
				cgprovince:'',
				subpkval:'',
				u_userid:'',
				p_mode:''
			},
			orderTable: [],
			windowHeight: (window.innerHeight * 88) / 100,
			checkweight_lang:{},
			scanordercount:0,
			scanorderweight:0,
			scanorderamount:0,
			ratebatch:'',
			currentcoltrol:'',
			issub:false
		};
	},
	mounted() {
		import('../../static/' + this.$theme + '/style/wm/storageprint.scss');
		this.init();
	},
	methods:{
		init(){
			var that=this;
			//debugger
			// this.$public.GetLanguageByMode('checkweight',this).then(res=>{
			// 	//debugger
			// 	if(res.state=='1'){
			// 		that.checkweight_lang=that.$lang.label.checkweight;
			// 	}
			// });
			this.form.batch=new Date().getTime();
			var that=this;
			this.$nextTick(function(e){
				that.$refs.pkval[0].focus();
			});
		},
		EnterEvent(control){
			//
			this.currentcoltrol=control;
			if(control=='handlebatch')
			{
				this.$refs.pkval[0].focus();
			}
			else if(control=='pkval'){
				//获取订单信息
				this.form.p_pkval=this.form.p_pkval.trim();
				this.GetOrderWeight();
			}
			else if(control=='subpkval'){
				this.form.subpkval=this.form.subpkval.trim();
				this.SetSubMark(this.form.subpkval);
			}
			else if(control=='weight')
			{
				this.form.grossweight=this.form.grossweight.trim();
				if(this.issub)
					this.SetSubMark(this.form.subpkval);
				else
					this.SetSubMark(this.form.p_pkval);
			}
		},
		GetOrderWeight(){
			var that = this;
			if(this.form.p_pkval=='')
				return false;
			this.$apipost.get.GetOrderWeight({pkval:this.form.p_pkval}).then(res => {
				if (res.state == '1') {
					if(res.list!=undefined){
						that.suborder=res.list;
						if(res.list.length>1)
						{
							that.trorder[1].isshow='1';
							that.issub=true;
							this.$nextTick(function(e){
								that.$refs.subpkval[0].focus();
							});
							this.$tool.ReadMsg('请扫描子单号');
						}
						else{
							//debugger
							this.form.p_height=res.list[0].p_height;
							this.form.p_width=res.list[0].p_width;
							this.form.p_length=res.list[0].p_length;
							//this.form.grossweight=res.list[0].grossweight;
							that.$refs.weight[0].focus();
						}
						this.form.vipaccount=res.list[0].vipaccount;
						this.form.perpay=res.list[0].perpay;
						this.form.cgprovince=res.list[0].cgprovince;
						this.form.u_userid=res.list[0].u_userid;
						this.form.p_mode=res.list[0].p_mode;
					}
				}else
					that.$refs.errorwin.init({errormsg:res.message,isread:true,focuscontrol:this.currentcoltrol});
			});
		},
		//设置子单标记
		SetSubMark(subpkval) {
			var that = this;
			var suborder = this.suborder;
			var list=this.suborder.filter(function(e){
				return e.p_pkval.toLowerCase() == subpkval.toLowerCase();
			});
			var scanlist=this.suborderscaned.filter(function(e){
				return e.p_pkval.toLowerCase() == subpkval.toLowerCase();
			});
			if(scanlist.length>0)
			{
				this.$refs.errorwin.init({errormsg:subpkval+'订单已扫描',isread:true,focuscontrol:this.currentcoltrol});
				
			}else{
				if(list.length>0){
					if(this.form.grossweight!='')
					{
						for (var i = 0; i < suborder.length; i++) {
							if (suborder[i].p_pkval.toLowerCase() == subpkval.toLowerCase()) {
								suborder[i].grossweight=this.form.grossweight;
								suborder[i].p_length=this.form.p_length;
								suborder[i].p_width=this.form.p_width;
								suborder[i].p_height=this.form.p_height;
								suborder[i].cgprovince=this.form.cgprovince;
								suborder[i].vipaccount=this.form.vipaccount;
								suborder[i].p_mode=this.form.p_mode;
								this.suborderscaned.push(suborder[i]);
								suborder.splice(i, 1);
								break;
							}
						}
						if (suborder.length == 0) {
							this.subscanfilish = true;
							this.CheckOrderWeight();
						}else{
							this.form.subpkval='';
							this.form.grossweight='';
							this.$refs.subpkval[0].focus();
						}
					}
					else{
						this.form.p_length=list[0].p_length;
						this.form.p_width=list[0].p_width;
						this.form.p_height=list[0].p_height;
						this.form.cgprovince=list[0].cgprovince;
						this.form.vipaccount=list[0].vipaccount;
						this.form.u_userid=list[0].u_userid;
						this.form.p_mode=list[0].p_mode;
						this.$refs.weight[0].focus();
					}
				}
				else{
					this.$refs.errorwin.init({errormsg:subpkval+'订单不存在',isread:true,focuscontrol:this.currentcoltrol});
				
				}
			}
		},
		CheckOrderWeight(){
			var that = this;
			var paraminfo={
				orderlist:this.suborderscaned,
				perpay:this.form.perpay
			}
			//debugger
			this.$apipost.post.CheckOrderWeight({paraminfo:paraminfo}).then(res => {
				if (res.state == '1') {
					that.ratebatch=res.batch;
					that.form.amount=res.amount;
					if(Number(res.amount)>0){//如果补差价的费用大于0，则发送邮件
						if(that.remind=='1'){
							//提示
							that.$refs.errorwin.init({errormsg:'此订单需补差价'+Number(res.amount),isread:true,isgo:true,focuscontrol:that.currentcoltrol});
						}else{
							that.AddStorageIn();
							//发送邮件
							that.SendEmailMsg();
						}
					}
					else 
						that.AddStorageIn();
				}else
					this.$tool.ReadMsg(res.message);
			});
		},
		AddStorageIn(){
			var that=this;
			var paraminfo={
				orderlist:this.suborderscaned,
				batch:this.form.batch,
				u_userid: localStorage.getItem('userid'),
				u_name: localStorage.getItem('u_name'),
				u_account: localStorage.getItem('u_account'),
				u_company: localStorage.getItem('u_company')
			}
			this.$apipost.post.AddStorageIn({paraminfo:paraminfo}).then(res => {
				if (res.state == '1') {
					this.$tool.ReadMsg('成功');
					that.orderTable.push({p_pkval:that.form.p_pkval,cgprovince:that.form.cgprovince,amount:that.form.amount,grossweight:that.form.grossweight});
					that.ScanSum();
					that.perpkval=that.form.p_pkval+'  '+that.form.cgprovince+' '+that.form.grossweight+' '+that.form.p_length+'*'+that.form.p_width+'*'+that.form.p_height;
					that.truncatepage();
				}else
					that.$refs.errorwin.init({errormsg:res.message,isread:true});
			});
		},
		SendEmailMsg(){
			var orderinfo=this.form;
			//orderinfo.diffprice=this.form.amount;
			debugger
			orderinfo.param=this.$public.encrypt(this.form.u_userid+'★'+this.ratebatch+'★'+this.form.p_pkval);
			this.$tool.SendEmailMsg(
			{msgid:'478-1',info:JSON.parse(JSON.stringify(orderinfo)) ,pkval:this.form.p_pkval,type:'1-q',showerror:false},this);
			
		},
		closeerrorwin(e){
			if(e.isgo){
				this.SendEmailMsg();
				this.AddStorageIn();
			}else{
				if(e.focuscontrol!=undefined)
					this.$refs[e.focuscontrol][0].focus();
				if(this.issub)
					this.form.subpkval='';
				else
					this.form.p_pkval='';
			}
		},
		truncatepage(){
			this.form.p_pkval='';
			this.form.grossweight='';
			this.form.p_length='';
			this.form.p_width='';
			this.form.p_height='';
			this.form.amount=0;
			this.form.perpay=0;
			this.form.vipaccount='';
			this.form.subpkval='';
			this.form.p_mode='';
			
			this.trorder[1].isshow=0;
			this.issub=false;
			this.subscanfilish=false;
			this.suborderscaned=[];
			this.suborder=[];
			this.$refs.pkval[0].focus();
		},
		ScanSum() {
			//计算汇总
			this.scanordercount = this.orderTable.length;
			var scanorderweight = 0,
				scanorderamount = 0.0;
			this.orderTable.forEach(e => {
				if (Number(e.grossweight)>0) scanorderweight += parseFloat(e.grossweight);
		
				if (Number(e.amount)>0) scanorderamount +=parseFloat(e.amount);
			});
			this.scanorderweight = scanorderweight.toFixed(3);
			this.scanorderamount = scanorderamount.toFixed(2);
		},
	}
}
</script>

<style>
</style>